import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Check2, Water, CarFrontFill, TruckFlatbed } from "react-bootstrap-icons";
import language from "../../data/language";
import { currentLanguage } from "../../common/ui/notify";
import PageHero from "../../common/ui/PageHero";
import ContactStrip from "../../common/ui/ContactStrip";
import "../../common/ui/ui.css";
import "./AboutUs.css";

const AboutUs = () => {
    const lang = currentLanguage();
    const about = language[lang].about;
    const home = language[lang].home_page;

    // The three vehicle families the company ships; the labels already exist as
    // the home page bullets, only the icons are new.
    const vehicles = [
        {icon: <Water />, label: home.divided_banner_bullet_1},
        {icon: <CarFrontFill />, label: home.divided_banner_bullet_2},
        {icon: <TruckFlatbed />, label: home.divided_banner_bullet_3}
    ];

    useEffect(() => {
        window.scrollTo({top: 0, behavior: "smooth"});
    }, [])

    return (
        <div className="cx-page about-page">
            <PageHero
                eyebrow={about.eyebrow}
                title={about.title}
                subtitle={about.subtitle}
            />

            <section className="cx-section cx-section-tight">
                <div className="container">
                    <div className="cx-stats">
                        {about.stats.map((stat) => (
                            <div className="cx-stat" key={stat.label}>
                                <span className="cx-stat-value">{stat.value}</span>
                                <span className="cx-stat-label">{stat.label}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="cx-section">
                <div className="container">
                    <div className="about-story">
                        <div className="about-story-copy">
                            <div className="cx-section-head">
                                <h2 className="cx-section-title">{about.story_title}</h2>
                            </div>
                            {/* The company profile is a translated HTML blob. */}
                            <div
                                className="cx-prose"
                                dangerouslySetInnerHTML={{__html: home.divided_banner_description2[0]}}
                            />
                        </div>
                        <div className="about-story-media">
                            <img src="/static/divided-banner-image-01.jpg" alt="" loading="lazy" />
                        </div>
                    </div>

                    <div className="about-vehicles">
                        {vehicles.map((item) => (
                            <div className="about-vehicle" key={item.label}>
                                <span className="about-vehicle-icon">{item.icon}</span>
                                <span>{item.label}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="cx-section about-offers-section">
                <div className="container">
                    <div className="cx-section-head">
                        <h2 className="cx-section-title">{about.offers_title}</h2>
                    </div>
                    <ul className="about-offers">
                        {about.offers.map((offer) => (
                            <li className="about-offer" key={offer}>
                                <span className="cx-check"><Check2 /></span>
                                <span>{offer}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </section>

            <section className="cx-section">
                <div className="container">
                    <div className="about-market">
                        <div className="about-market-media">
                            <img src="/static/main-page-paralax-image-01.jpg" alt="" loading="lazy" />
                        </div>
                        <div className="about-market-copy">
                            <div className="cx-section-head">
                                <h2 className="cx-section-title">{about.market_title}</h2>
                            </div>
                            <div
                                className="cx-prose"
                                dangerouslySetInnerHTML={{__html: home.divided_banner_description2[2]}}
                            />
                        </div>
                    </div>
                </div>
            </section>

            <section className="cx-section cx-section-tight">
                <div className="container">
                    <div className="cx-cta">
                        <div>
                            <h2 className="cx-cta-title">{about.cta_title}</h2>
                            <p className="cx-cta-text">{about.cta_text}</p>
                        </div>
                        <div className="cx-cta-actions">
                            <Link to="/market" className="cx-btn cx-btn-ghost">{about.browse_cars}</Link>
                            <Link to="/contact" className="cx-btn cx-btn-primary">
                                {about.cta_button} <ArrowUpRight />
                            </Link>
                        </div>
                    </div>

                    <div className="about-contact">
                        <ContactStrip />
                    </div>
                </div>
            </section>
        </div>
    )
}

export default AboutUs
